var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompetitors({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_234_7836)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.328107,
    y: 0.00467923,
    width: 0.46486,
    height: 6.61845,
    rx: 0.23243,
    transform: "matrix(0.715919 -0.698183 0.695718 0.718315 6.24864 13.3237)",
    fill: "#56627C",
    stroke: "#E9EBF0",
    strokeWidth: 0.46486
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.328107,
    y: 0.00467923,
    width: 0.46486,
    height: 6.61845,
    rx: 0.23243,
    transform: "matrix(0.715919 -0.698183 0.695718 0.718315 5.51964 14.06)",
    fill: "#56627C",
    stroke: "#E9EBF0",
    strokeWidth: 0.46486
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_234_7836",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5498 14.6792L9.64435 16.827L6.78068 19.6197C6.38529 20.0053 5.75217 19.9973 5.36658 19.602L4.66839 18.886C4.2828 18.4906 4.29074 17.8575 4.68613 17.4719L7.5498 14.6792Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.5498 14.6792L9.64435 16.827L6.78068 19.6197C6.38529 20.0053 5.75217 19.9973 5.36658 19.602L4.66839 18.886C4.2828 18.4906 4.29074 17.8575 4.68613 17.4719L7.5498 14.6792Z",
    stroke: "#E9EBF0",
    strokeWidth: 3,
    mask: "url(#path-3-inside-1_234_7836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28483 14.3352L15.443 5.58521L20.0521 4.58228L18.9339 9.16481L10.0312 16.1241",
    stroke: "#E9EBF0",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.00456384,
    y: -0.328109,
    width: 0.46486,
    height: 6.61845,
    rx: 0.23243,
    transform: "matrix(-0.698435 -0.715674 0.71807 -0.695971 13.3405 17.9468)",
    fill: "#56627C",
    stroke: "#E9EBF0",
    strokeWidth: 0.46486
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.00456384,
    y: -0.328109,
    width: 0.46486,
    height: 6.61845,
    rx: 0.23243,
    transform: "matrix(-0.698435 -0.715674 0.71807 -0.695971 14.0773 18.6758)",
    fill: "#56627C",
    stroke: "#E9EBF0",
    strokeWidth: 0.46486
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_234_7836",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6826 17.1084L16.8296 15.0131L19.4459 17.6939C19.8316 18.0891 19.8239 18.7223 19.4286 19.108L18.7129 19.8064C18.3177 20.1922 17.6846 20.1844 17.2988 19.7892L14.6826 17.1084Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.6826 17.1084L16.8296 15.0131L19.4459 17.6939C19.8316 18.0891 19.8239 18.7223 19.4286 19.108L18.7129 19.8064C18.3177 20.1922 17.6846 20.1844 17.2988 19.7892L14.6826 17.1084Z",
    stroke: "#E9EBF0",
    strokeWidth: 3,
    mask: "url(#path-7-inside-2_234_7836)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81528 11.903L5.58573 9.21865L4.58118 4.60987L9.1641 5.72648L11.8153 8.40298",
    stroke: "#E9EBF0",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4586 16.5438L13.2368 15.3159",
    stroke: "#E9EBF0",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1626 14.396L15.1577 13.4009",
    stroke: "#E9EBF0",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_234_7836",
    x: -4,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_234_7836"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_234_7836",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitors);
export default __webpack_public_path__ + "static/media/competitors.269c688b2918c841f332455e88710c3f.svg";
export { ForwardRef as ReactComponent };